import {on, trigger} from './util/event'
import api from './api'


const changeEventName               = 'change.kiosk.userCategoryPresets',
      successChangeEventName        = 'changed.kiosk.userCategoryPresets',
      categoryPresetPath          = '/api/category-preset';

on(changeEventName, function(e) {

  const eventData = e.detail,
      name          = eventData.name || null
  ;

  if (categoryPresetPath !== null) {
    api.post(categoryPresetPath, {name: name}).then((response) => {
      const data = response.data;
      if (data.result) {
        trigger(successChangeEventName, {});
      }
    })

  }

});

on(successChangeEventName, function(e) {





});

const userCategoryPresets = {
  changeEventName: changeEventName,
  changedEventName: successChangeEventName,
};


export default userCategoryPresets;
